function openCartDrawer() {
    // 🛡️ GUARD: If already on the standalone /cart page, do not open the side drawer overlay.
    // Instead, smoothly scroll to the order summary / checkout section.
    if (window.location.pathname === '/cart' || window.location.pathname.startsWith('/cart')) {
        const checkoutBtn = document.getElementById('main-checkout-btn') || document.getElementById('main-cart-container');
        if (checkoutBtn) {
            checkoutBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return;
    }

    const drawer = document.getElementById('cart-drawer');
    const backdrop = document.getElementById('cart-drawer-backdrop');
    if (drawer) {
        drawer.style.transform = '';
        drawer.style.transition = '';
        drawer.classList.remove('translate-x-full');
        drawer.setAttribute('aria-hidden', 'false');
    }
    if (backdrop) backdrop.classList.remove('pointer-events-none', 'opacity-0');
    
    // 🔒 Lock body scroll to prevent background scroll bleeding on mobile
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overscrollBehavior = 'none';

    // Update all trigger elements
    document.querySelectorAll('[data-cart-trigger]').forEach((el) => {
        el.setAttribute('aria-expanded', 'true');
    });
}

function closeCartDrawer() {
    const drawer = document.getElementById('cart-drawer');
    const backdrop = document.getElementById('cart-drawer-backdrop');
    if (drawer) {
        drawer.style.transform = '';
        drawer.style.transition = '';
        drawer.classList.add('translate-x-full');
        drawer.setAttribute('aria-hidden', 'true');
    }
    if (backdrop) backdrop.classList.add('pointer-events-none', 'opacity-0');
    
    // 🔓 Unlock body scroll
    document.body.style.overflow = '';
    document.documentElement.style.overscrollBehavior = '';

    // Update all trigger elements
    document.querySelectorAll('[data-cart-trigger]').forEach((el) => {
        el.setAttribute('aria-expanded', 'false');
    });
}

// Issue #1 Fix: Progressive enhancement for cart icon.
// Opens the drawer if JS is loaded and #cart-drawer exists in the DOM.
// If JS fails or the drawer is missing, the <a href="/cart"> navigates normally.
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-cart-trigger]').forEach(function (el) {
        el.addEventListener('click', function (e) {
            if (window.location.pathname === '/cart' || window.location.pathname.startsWith('/cart')) {
                e.preventDefault();
                const checkoutBtn = document.getElementById('main-checkout-btn') || document.getElementById('main-cart-container');
                if (checkoutBtn) {
                    checkoutBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
                return;
            }
            const drawer = document.getElementById('cart-drawer');
            if (drawer) {
                e.preventDefault();
                openCartDrawer();
            }
            // No preventDefault() here — href="/cart" fires as a safe fallback
        });
    });

    // Backdrop click listener to close the drawer
    const backdrop = document.getElementById('cart-drawer-backdrop');
    if (backdrop) {
        backdrop.addEventListener('click', closeCartDrawer);
    }

    // Escape key listener for accessibility & quick close
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' || e.keyCode === 27) {
            const drawer = document.getElementById('cart-drawer');
            if (drawer && !drawer.classList.contains('translate-x-full')) {
                closeCartDrawer();
            }
        }
    });

    // 📱 Swipe-to-close gesture handling for mobile side drawer
    const drawer = document.getElementById('cart-drawer');
    if (drawer) {
        let startX = 0;
        let startY = 0;
        let isSwipingRight = false;

        drawer.addEventListener('touchstart', function (e) {
            if (e.touches.length !== 1) return;
            startX = e.touches[0].clientX;
            startY = e.touches[0].clientY;
            isSwipingRight = false;
        }, { passive: true });

        drawer.addEventListener('touchmove', function (e) {
            if (e.touches.length !== 1) return;
            const currentX = e.touches[0].clientX;
            const currentY = e.touches[0].clientY;
            const deltaX = currentX - startX;
            const deltaY = currentY - startY;

            // Determine if horizontal swipe to the right is dominant
            if (deltaX > 15 && Math.abs(deltaX) > Math.abs(deltaY) * 1.3) {
                isSwipingRight = true;
                // Live drag feedback with slight resistance
                drawer.style.transition = 'none';
                drawer.style.transform = `translateX(${deltaX}px)`;
            }
        }, { passive: true });

        drawer.addEventListener('touchend', function (e) {
            if (!isSwipingRight || e.changedTouches.length !== 1) {
                if (drawer.style.transform) {
                    drawer.style.transition = 'transform 0.2s ease-out';
                    drawer.style.transform = '';
                }
                return;
            }
            const deltaX = e.changedTouches[0].clientX - startX;

            // If swiped right more than 75px, close drawer
            if (deltaX > 75) {
                closeCartDrawer();
            } else {
                // Snap back
                drawer.style.transition = 'transform 0.2s ease-out';
                drawer.style.transform = '';
            }
            isSwipingRight = false;
        }, { passive: true });
    }
});